import React from 'react';
import { PropTypes } from 'prop-types';

import { Box } from '@mui/material';

const AdvisorInsights = ({ currentUser }) => {
  return (
    <Box sx={{ borderBottom: '1px solid #ccc', pb: 2 }}>
      Insights for&nbsp;
      {currentUser.login}
    </Box>
  );
};

AdvisorInsights.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

export default AdvisorInsights;
